import { all } from "redux-saga/effects";
import { dashboardSaga } from "./Dashboard/dashboardSaga";
import { notificationSaga } from "./Notification/notificationSaga";
import { sellSaga } from "./Sell/sellSaga";
import { profileSaga } from "./Profile/profileSaga";
import { giftSaga } from "./Gifts/giftSaga";
import {redeemSaga} from "./Redeem/redeemSaga";
import { passbookSaga } from "./Passbook/passbookSaga";
import { sipSaga } from "./Sip/sipSaga";
import {offlineOrderSaga} from "./OfflineOrder/offlineOrderSaga"
import { diamondPointSaga } from "./DiamondPoint/DiamondPointSaga";
import onlineOrderSaga from "./OnlineOrder/onlineOrderSaga";
import { productSaga } from "./Products/productSaga";
import { productOrderSaga } from "./ProductOrder/productOrderSaga";
import { depositSaga } from "./DepositePlan/depositeSaga";
import { customerInteractionSaga } from "./CustomerInteraction/customerInteractionSaga";
import { muhuratSaga } from "./MuhuratCalender/muhuratSaga";
import { jewellerySaga } from "./Jewellery/jewellerySaga";

export default function* rootSaga() {
  yield all([dashboardSaga(),notificationSaga(),sellSaga(),profileSaga(), giftSaga(),redeemSaga(),passbookSaga(),sipSaga(),
    offlineOrderSaga(),diamondPointSaga(),onlineOrderSaga(), productSaga(), productOrderSaga(),depositSaga(),customerInteractionSaga()
    ,muhuratSaga(), jewellerySaga()
  ]);
}
